export default __webpack_public_path__ + "static/media/franchiseImg.18bf8cdc.webp";